import * as React from "react";
import MainGrid from "./components/MainGrid";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useSelector } from "react-redux";
import Pricing from "../landingPage/components/Pricing";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";

export default function Dashboard(props) {
  const auth = useSelector((state) => state.user);
  const [stripeProducts, setStripeProducts] = React.useState([]);

  const fetchStripeProducts = async () => {
    const response = await callBackendApi("/stripe-products", "GET");
    if (response.success) {
      setStripeProducts(response.data);
    }
  };

  React.useEffect(() => {
    fetchStripeProducts();
    console.log(stripeProducts)
  }, []);
  
  return (
    <React.Fragment>
      <DashboardLayout>
        {auth.user.role === "CUSTOMER" && stripeProducts.length > 0 && (
          <div>
            <Pricing stripeProducts={stripeProducts} />
          </div>
        )}
        <MainGrid />
      </DashboardLayout>
    </React.Fragment>
  );
}
